import { cn } from "@client/lib/cn";
import { discountPercent, formatRupiah } from "@client/lib/format";
import { catalogCopy } from "@client/locales/id/catalog";

interface PriceTagProps {
  price: number;
  normalPrice: number;
  size?: "md" | "lg";
  className?: string;
}

export function PriceTag({ price, normalPrice, size = "md", className }: PriceTagProps) {
  const percent = discountPercent(normalPrice, price);
  return (
    <div className={cn("flex flex-wrap items-baseline gap-x-2 gap-y-1", className)}>
      <span
        className={cn(
          "font-semibold tracking-tight text-foreground",
          size === "lg" ? "text-3xl" : "text-lg",
        )}
      >
        {formatRupiah(price)}
      </span>
      {percent > 0 && (
        <>
          <s className="text-sm text-foreground-muted">{formatRupiah(normalPrice)}</s>
          <span className="rounded-full border border-success/30 bg-success/10 px-2 py-0.5 text-xs font-medium text-success">
            {catalogCopy.discount(percent)}
          </span>
        </>
      )}
    </div>
  );
}
